// Slick Carousel
$(document).ready(function(){
  $('.slide-text-and-image-section').each(function() {
    const $section = $(this);
    const $carousel = $section.find('.slick-carousel1');
    const $dotsContainer = $section.find('.slick-dots-container');

    $carousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      appendDots: $dotsContainer,
      arrows: false,
      draggable: true,
      infinite: true,
      swipeToSlide: true,
    });

    $section.find('.slick-prev').on('click', function() {
      $carousel.slick('slickPrev');
    });

    $section.find('.slick-next').on('click', function() {
      $carousel.slick('slickNext');
    });
  });
});
